import React from "react"

import {
    Button,
    ButtonContainer,
    Container,
    Error,
    Label,
} from "QuorumGrassroots/campaign-forms/components/PersonalizedMessages/components/BooleanField.styles"
import { CustomField } from "@/types/djangio"
import { useFormReturn } from "QuorumGrassroots/campaign-forms/hooks/useForm"
import { PromptAndResponseCampaignForm } from "../PersonalizedMessages.helper"

interface Props {
    question: CustomField
    form: useFormReturn<PromptAndResponseCampaignForm>
    disabled?: boolean
}

export const BooleanField = ({ question, form, disabled = false }: Props) => {
    const handleChange = (value: boolean) => {
        form.setFieldValue(question.slug, value, true)
    }

    const currentValue = form.values[question.slug]

    return (
        <Container>
            <Label>{question.external_name}</Label>
            <ButtonContainer>
                <Button
                    isSelected={currentValue === true}
                    onClick={() => handleChange(currentValue === true ? null : true)}
                    disabled={disabled}
                >
                    Yes
                </Button>
                <Button
                    isSelected={currentValue === false}
                    onClick={() => handleChange(currentValue === false ? null : false)}
                    disabled={disabled}
                >
                    No
                </Button>
            </ButtonContainer>
            {form.errors[question.slug] && <Error>{form.errors[question.slug]}</Error>}
        </Container>
    )
}
